import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-2.5 px-3 rounded-lg bg-white mb-2 shadow-lg" }
const _hoisted_2 = { class: "flex justify-between mt-1 h-7" }
const _hoisted_3 = { class: "overflow-hidden text-lg whitespace-nowrap overflow-ellipsis" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "ml-1 text-gray-400" }
const _hoisted_6 = { class: "flex justify-between h-6 mt-2" }
const _hoisted_7 = { class: "overflow-hidden text-gray-400 overflow-ellipsis whitespace-nowrap" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_10 = { class: "ml-1 text-xs" }
const _hoisted_11 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_12 = { class: "ml-1 text-xs" }
const _hoisted_13 = { class: "flex ml-2 text-gray-400" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5" }, null, -1)
const _hoisted_16 = { class: "ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_five_stars = _resolveComponent("five-stars")!
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.lecture.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_five_stars, {
          score: 3,
          size: 20
        }),
        _createElementVNode("span", _hoisted_5, _toDisplayString((_ctx.lecture.score || 3).toFixed(1)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.lecture.teachers.join(' ')), 1),
      _createElementVNode("div", _hoisted_8, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_f_icon, {
                name: "reaction",
                size: "14"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.lecture.reactionCount), 1)
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_f_icon, {
                name: "heart",
                size: "14"
              }),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.lecture.likeCount), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_f_icon, {
              class: "align-baseline",
              name: "chat",
              size: "14"
            })
          ]),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.lecture.ratingCount), 1)
        ])
      ])
    ])
  ]))
}